import React from 'react';
import { FaMoneyBillWave, FaInfoCircle, FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';
import { formatMoney } from '../../../services/cadastral.service';
import styles from '../../../styles/Cadastral.module.css';

function Block({ title, icon: Icon, children }) {
  return (
    <div className={styles.block}>
      <div className={styles.blockTitle}>
        <span className={styles.btIco}><Icon size={13} /></span>
        {title}
      </div>
      {children}
    </div>
  );
}

function Dl({ items, singleCol = false }) {
  return (
    <dl className={`${styles.dl} ${singleCol ? styles.one : ''}`}>
      {items.map(([label, val, className = ''], index) => (
        <div key={index}>
          <dt>{label}</dt>
          <dd className={styles[className] || className}>{val}</dd>
        </div>
      ))}
    </dl>
  );
}

export default function FiscalTab({ file }) {
  const fiscalData = file.fiscal;
  const hasOutstandingBalance = fiscalData.debtAmount > 0;

  const taxPeriods = [
    ['Periodo inicial adeudado', fiscalData.startPeriod, 'num'],
    ['Periodo final adeudado', fiscalData.endPeriod, 'num'],
    ['Bimestres pendientes', String(fiscalData.bimonthlyPeriods), 'num'],
    ['Base del impuesto predial', formatMoney(file.cadastralValue), 'num'],
    ['Cuenta predial', file.registry.account, 'mono'],
    ['Ejercicio fiscal vigente', file.registry.fiscalYear, 'num']
  ];

  return (
    <div className={styles.tabContentFade}>
      <Block title="Estado de cuenta" icon={FaMoneyBillWave}>
        <div className={`${styles.fiscalAlert} ${hasOutstandingBalance ? styles.debt : styles.clear}`}>
          <span className={styles.faIco}>
            {hasOutstandingBalance ? <FaExclamationTriangle size={19} /> : <FaCheckCircle size={19} />}
          </span>
          <div style={{ flex: 1 }}>
            <strong>
              {hasOutstandingBalance
                ? 'El predio presenta adeudo de impuesto predial'
                : 'El predio se encuentra al corriente'}
            </strong>
            <p>
              {hasOutstandingBalance
                ? `Se registran ${fiscalData.bimonthlyPeriods} bimestres pendientes de pago ante la Secretaría de Finanzas del Municipio de Querétaro.`
                : 'No se registran periodos pendientes de pago.'}
            </p>
            {hasOutstandingBalance && (
              <>
                <div className={styles.amountBig}>{formatMoney(fiscalData.debtAmount)}</div>
                <div className={styles.amountTxt}>{fiscalData.debtText}</div>
              </>
            )}
          </div>
        </div>

        <Dl items={taxPeriods} />
      </Block>

      <Block title="Fundamento" icon={FaInfoCircle}>
        <div className={styles.stateDetail}>
          El valor catastral constituye la base del impuesto predial conforme a los artículos 42 fracciones I y II
          y 44 inciso a) de la <strong>Ley de Hacienda de los Municipios del Estado de Querétaro</strong>, y puede
          modificarse durante el año calendario si se actualiza alguno de los supuestos previstos en dicho ordenamiento.
        </div>
      </Block>
    </div>
  );
}